/**
 * @file 读 cooke
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/cookie
 */

/**
 * 转义正则关键字字符
 *
 * @param {string} string 需要转义的字符
 * @return {string} 转义后的字符
 * @inner
 */
var escapeRegExp = function escapeRegExp(string) {
  return String(string).replace(/([\$\(-\+\x2D-\/\?\[-\^\{-\}])/g, '\\$1');
};

export default {
  /**
   * 读取 Cookie 中指定键的值
   *
   * @param {string} key 要读取的 Cookie 键名
   * @param {string=} [cookie=document.cookie] 要读取的 Cookie
   * @return {string}
   */
  get: function get(key) {
    var cookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var cookieValue = cookie;

    if (typeof document !== 'undefined' && !cookieValue) {
      var _document = document,
          _cookie = _document.cookie;
      cookieValue = _cookie;
    }

    var value = cookieValue.match("(?:^|;)\\s*".concat(escapeRegExp(key), "=([^;]*)"));
    return value ? decodeURIComponent(value[1]) : '';
  }
};